import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SdvorButtonComponent } from '@sdvor/shared/ui/v2';
import { ButtonSizes, ButtonThemes } from '@shared/v2';
import { ModalService } from '@spartacus/storefront';
import { CustomCloseAccountModalComponent } from '../custom-close-account-modal/custom-close-account-modal.component';

@Component({
  selector: 'sd-custom-close-account',
  templateUrl: './custom-close-account.component.html',
  styleUrls: ['./custom-close-account.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SdvorButtonComponent],
})
export class CustomCloseAccountComponent {
  buttonThemes = ButtonThemes;
  buttonSizes = ButtonSizes;

  constructor(private modalService: ModalService) {}

  openModal(): void {
    this.modalService.open(CustomCloseAccountModalComponent, {
      centered: true,
      windowClass: 'close-account-modal',
      animation: false,
    });
  }
}
